import styled from 'styled-components';
import { IconButton, BUTTON_VARIANTS } from 'ui/button';
import { Close16 } from 'ui/icons/action/Close16';

const StyledButton = styled(IconButton)`
  margin: 0 ${({ theme }) => theme.spacing.values.plusHalf};
`;

type DrawerCloseButtonProps = {
  onClose: () => void;
};

export const DrawerCloseButton = ({ onClose }: DrawerCloseButtonProps) => (
  <StyledButton data-test="drawer--close-button" onClick={onClose} variant={BUTTON_VARIANTS.GHOST}>
    <Close16 />
  </StyledButton>
);
